// extracted by mini-css-extract-plugin
export default {"inputWrapper":"NumberInput_inputWrapper__lAdpw","label":"NumberInput_label__RZdpu","input":"NumberInput_input__eSDi8","errorMessage":"NumberInput_errorMessage__nDzIJ"};